// API Configuration
// Always use remote backend (production server)
export const API_CONFIG = {
  // Fileserver URL (for patient data and file uploads)
  // Using remote backend for both localhost and production
  FILESERVER_URL: 'https://bucket.roamjet.net',
  // OpenChat Server URL (LOCAL ONLY - no online LLM services)
  // OpenChat connects to your local Ollama LLM container
  // Default: OpenChat runs on http://localhost:8000 (Docker container port)
  // OpenChat uses local Ollama at http://localhost:11434 - 100% local, no external API calls
  OPENCHAT_SERVER_URL: process.env.REACT_APP_OPENCHAT_SERVER_URL || 'http://localhost:8000',
};

// Helper function to get full API URL
export const getApiUrl = (path: string) => {
  return `${API_CONFIG.FILESERVER_URL}${path}`;
};

// Helper function to get AI API URL (OpenChat server)
// Note: The backend server should proxy these requests to OpenChat
// OpenChat will handle communication with your Ollama LLM backend
export const getAiApiUrl = (path: string) => {
  // For AI endpoints, backend will handle routing to OpenChat server
  // OpenChat is configured to use your Ollama instance
  return `${API_CONFIG.FILESERVER_URL}${path}`;
};

